import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import { getEntriesOfContentType } from "@/lib/contentful/guards";
import { cn } from "@/lib/utils";
import type { TypeFooterNavSkeleton } from "@/types/contentful/generated";
import { FooterNavLink, type FooterNavLinkEntry } from "./FooterNavLink";
type FooterNavEntry = Entry<TypeFooterNavSkeleton, undefined, string>;
const GRID_COLS_MD: Record<number, string> = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
  5: "md:grid-cols-5",
  6: "md:grid-cols-6",
  7: "md:grid-cols-7"
};
interface Props {
  navSections: unknown[];
}
export function FooterNavGrid(t0) {
  const $ = _c(9);
  const {
    navSections
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== navSections) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const columns = getEntriesOfContentType(navSections, "footerNav");
      if (columns.length === 0) {
        t3 = null;
        break bb0;
      }
      const t4 = GRID_COLS_MD[columns.length];
      if ($[4] !== t4) {
        t1 = cn("grid grid-cols-1 gap-6 py-12 md:py-0", t4);
        $[4] = t4;
        $[5] = t1;
      } else {
        t1 = $[5];
      }
      t2 = columns.map(_temp);
    }
    $[0] = navSections;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(column, index) {
  return <FooterNavColumn key={`${column.sys.id}-${index}`} column={column} />;
}
function FooterNavColumn(t0) {
  const $ = _c(15);
  const {
    column
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== column.fields.links || $[1] !== column.fields.sectionHeader) {
    const links = getEntriesOfContentType(column.fields.links ?? [], "footerNavLinks");
    t3 = "flex flex-col gap-2";
    if ($[6] !== column.fields.sectionHeader) {
      t4 = <h3 className="text-base font-bold leading-none">{column.fields.sectionHeader}</h3>;
      $[6] = column.fields.sectionHeader;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t1 = "flex flex-col gap-1.5";
    t2 = links.map(_temp2);
    $[0] = column.fields.links;
    $[1] = column.fields.sectionHeader;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2) {
    t5 = <ul className={t1}>{t2}</ul>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp2(link, index) {
  return <FooterNavLink key={`${link.sys.id}-${index}`} link={link} />;
}